import styled, { css } from "styled-components";
import { Black, White } from "../../Theme/ColorPallete";
import { darken, lighten, rgba } from "polished";

interface Props {
    $active: boolean;
}

export const MobileMenuCenterLink = styled.a`
    text-decoration: none;
    &:hover {
        cursor: pointer;
    }
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    padding: 6px;
    ${({ theme }) => css`
        background: ${theme.colors.discordBlue};
    `}
`;
export const MobileMenuCenterLinkText = styled.div`
    text-transform: uppercase;
    font-weight: 600;
    color: ${White};
    ${({ theme }) => css`
        font-size: ${theme.fontSize.small}px;
    `}
`;
export const MobileMenuCenterLinkIcon = styled.img`
    width: 20px;
    height: 20px;
`;

export const MobileMenuSVG = styled.svg``;

export const MobileMenuPathStyled = styled.path``;

interface NavContainerProps {
    $show: boolean;
}

export const NavContainer = styled.div<NavContainerProps>`
    position: fixed;
    top: 0;
    height: 70px;
    padding: 0px 20px;
    width: calc(100% - 40px);
    transform: translateY(${({ $show }) => ($show ? "-70px" : "0px")});
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    opacity: 1;
    caret-color: transparent;
    ${({ theme }) => css`
        transition: ${theme.animationTime.short}s all ease;
        background: ${rgba(theme.colors.background, 0.9)};
        border-bottom: 1px solid
            ${theme.colors.background === Black
                ? lighten(0.02, theme.colors.background)
                : darken(0.03, theme.colors.background)};
    `}
`;

export const IconTextMoonContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    gap: 10px;
`;

export const MobileIcon = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.text};
`;

export const MobileMenuText = styled.div`
    font-weight: 700;
    font-size: 25px;
    text-align: cetner;
    color: ${(props) => props.theme.colors.text};
`;

export const FakeCheckBox = styled.input<Props>`
    position: relative;
    top: 0;
    left: calc(100% - 30px);
    padding: 0;
    margin: 0;
    width: 30px;
    height: 50px;
    z-index: ${(props) => (props.$active ? "5" : "3")};
    opacity: 0;
`;

export const BurgerCheckHolder = styled.div`
    z-index: 2;
    caret-color: transparent;
    height: 50px;
    width: 72px;
`;

export const SpanOne = styled.div<Props>`
    transition: 0.3s all ease;
    position: relative;
    z-index: 2;
    height: 4px;
    width: 30px;
    border-radius: 10px;
    margin-left: auto;
    ${({ theme, $active }) => css`
        top: ${$active ? "-30px" : "-40px"};
        background: ${$active
            ? theme.colors.background
            : theme.colors.backgroundOpposite};
        transform: rotate(${$active ? "-45deg" : "0deg"});
    `}
`;

export const SpanTwo = styled.div<Props>`
    transition: 0.3s all ease;
    position: relative;
    top: -34px;
    height: 4px;
    width: 30px;
    margin-left: auto;
    opacity: ${(props) => (props.$active ? "0" : "1")};
    border-radius: 10px;
    ${({ theme, $active }) => css`
        background: ${theme.colors.backgroundOpposite};
        opacity: ${$active ? "0" : "1"};
    `}
`;

export const SpanThree = styled.div<Props>`
    transition: 0.3s all ease;
    position: relative;
    z-index: 2;
    height: 4px;
    width: 30px;
    margin-left: auto;
    border-radius: 10px;
    ${({ theme, $active }) => css`
        top: ${$active ? "-38px" : "-28px"};
        background: ${$active
            ? theme.colors.background
            : theme.colors.backgroundOpposite};
        transform: rotate(${$active ? "45deg" : "0deg"});
    `}
`;

export const Card = styled.div<Props>`
    transition: 0.3s all ease;
    z-index: 1;
    position: absolute;
    right: 0;
    width: 100vw;
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    ${({ theme, $active }) => css`
        top: ${$active ? "0" : "-2000px"};
        background: ${theme.colors.backgroundOpposite};
        @media screen and (max-width: ${theme.breakpoint}px) {
            height: 100vh;
        }
    `}
`;

export const CardItem = styled.div`
    color: ${(props) => props.theme.colors.background};
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer;
`;
